import React, { useEffect, useState } from 'react';
import { useGetBinMappings } from '../../helpers/mappings';
import { useParams } from 'react-router-dom';
import { AppShell } from '../AppShell';
import Returnable from '../../assets/bins/returnables.jpeg';
import Landfill from '../../assets/bins/landfill.jpeg';
import NoBin from '../../assets/bins/stop.jpeg';
import Organic from '../../assets/bins/organic.jpeg';
import Recycle from '../../assets/bins/recycle.jpeg';
import styles from './searchresult.module.css';
import { BinInformation } from './BinInformation';
import { AdditionalInfo } from '../AdditionalInfo';
var getBinToImage = function (note) {
    switch (note) {
        case 'Recycle':
            return Recycle;
        case 'Landfill':
            return Landfill;
        case 'Recycle-Returnables':
            return Returnable;
        case 'Organic Waste':
            return Organic;
        case 'Cannot throw in community':
            return NoBin;
    }
};
export var SearchResult = function () {
    var id = useParams().id;
    var _a = useState(undefined), item = _a[0], setItem = _a[1];
    var _b = useState(undefined), location = _b[0], setLocation = _b[1];
    var mappings = useGetBinMappings();
    useEffect(function () {
        if (!mappings)
            return;
        setItem(mappings.get(Number(id)));
    }, [mappings, id]);
    if (!item) {
        return React.createElement("h1", null, "Loading...");
    }
    return (React.createElement(AppShell, null,
        React.createElement("div", { className: styles.resultsContainer },
            React.createElement(BinInformation, { name: item.item, bin: item.bin, image: getBinToImage(item.bin), notes: item.notes }),
            item.notes.trim().length > 0 && React.createElement(AdditionalInfo, { note: item.notes }))));
};
